module.exports = __webpack_public_path__ + "img/time.1e8ae815.svg";